<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <textarea formControlName="questionDesc" id="questionDesc" [rows]="1" pInputTextarea></textarea>
            <label for="questionDesc">Question Desc</label>
            @for (validation of validationMessages.questionDesc; track validation) {
              <span>
                @if (form1.get('questionDesc').hasError(validation.type) && (form1.get('questionDesc').dirty || form1.get('questionDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="answerDesc"><strong>Answer Desc :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="opsNotes" id="opsNotes" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="answerDesc"
              id="answerDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.answerDesc; track validation) {
              <span>
                @if (form1.get('answerDesc').hasError(validation.type) && (form1.get('answerDesc').dirty || form1.get('answerDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="displayOrder" id="displayOrder" type="number" pInputText>
            <label for="displayOrder">Display Order</label>
            @for (validation of validationMessages.displayOrder; track validation) {
              <span>
                @if (form1.get('displayOrder').hasError(validation.type) && (form1.get('displayOrder').dirty || form1.get('displayOrder').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['enabled']" inputId="enabled" [binary]="true"></p-checkbox>
            <span class="faqCategory-nm">Enabled?</span>
          </div>
          @for (validation of validationMessages.enabled; track validation) {
            <span>
              @if (form1.get('enabled').hasError(validation.type) && (form1.get('enabled').dirty || form1.get('enabled').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
            <label for="opsNotes">Ops Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- <h2>Overview</h2><hr>	 -->
        @if (faqCategory!= undefined && faqCategory?.faqSections.length > 0) {
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-4">
              <p-multiSelect class="lead-select" [options]="faqCategory?.faqSections" formControlName="availableDays" (onChange)="onChangeReAssignFaq($event)" appendTo="body"
              defaultLabel="Available Days" optionLabel="name" display="chip"></p-multiSelect>
              <label for="availableDays">Re-Assign this FAQ to a different Section under the same category</label>
            </span>
          </div>
        }

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (faqId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!faqId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (faqId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>